import apiClient from '../../../Services/ApiClient';

interface UseWizardTreeProps {
	wizardKey: string;
	params?: any;
}

const useWizardTree = (props: UseWizardTreeProps) => {
	const { wizardKey, params } = props;

	const handleGet = async () => {
		const urlParams = params ? new URLSearchParams(params).toString() : '';

		const result = await apiClient.get(
			`/wizard/${wizardKey}/tree?${urlParams}`,
		);

		return result?.data || [];
	};

	const handlePost = async (data: object) => {
		const result = await apiClient.post(`/wizard/${wizardKey}/tree`, data);

		return result?.data || [];
	};

	return {
		getWizard: handleGet,
		postWizard: handlePost,
	};
};

export default useWizardTree;
